import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Item from '../../../events/projects/Item';

const getProject = (event) =>
  event.data.project ? event.data.project : event.data.memo.project;

const renderItems = (projectEvents) =>
  projectEvents.map((event) => (
    <Item
      key={event.createdAt}
      project={getProject(event)}
      events={[event]}
      isCurrentUser={true}
    />
  ));

const List = ({ events, t }) => {
  return (
    <React.Fragment>
      <h3>
        <span className="u-color-fountain-blue">
          {t('manageUpdates.projectsTitlePrefix')}
        </span>
        {t('manageUpdates.projectsTitle')}
        <span className="u-color-fountain-blue">
          {t('manageUpdates.projectsTitleSuffix')}
        </span>
      </h3>
      {events.length ? (
        <div className="c-box c-box-primary">{renderItems(events)}</div>
      ) : (
        <React.Fragment>
          <p className="u-weight-light">
            {t('manageUpdates.noProjectUpdates')}
          </p>
          <Link to="/my-profile" className="c-btn c-btn-outline">
            {t('general.goProjects')}
          </Link>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state, { userEvents }) => ({
  events: userEvents.filter(
    ({ action }) =>
      action === 'UNJOIN_PROJECT' ||
      action === 'JOIN_PROJECT' ||
      action === 'ADD_PROJECT_MEMO'
  ),
});

export default connect(mapStateToProps)(translate()(List));



// WEBPACK FOOTER //
// ./src/updates/user-updates/projects/List.js